import PortalService from '@/services/portal.service';

export const company = {
  namespaced: true,

  state: {
    companiesAvailable: {}
  },

  actions: {
    async initCompaniesAvailable({ commit }) {
      commit('update', await PortalService.getCompanies());
    }
  },

  mutations: {
    update(state, payload) {
      state.companiesAvailable = payload.data;
    }
  },

  getters: {
    companiesAvailable(state) {
      return state.companiesAvailable;
    }
  }
};
